import { render, staticRenderFns } from "./lawsuit-case-reply-card.vue?vue&type=template&id=7a3ffd66&scoped=true&"
import script from "./lawsuit-case-reply-card.vue?vue&type=script&lang=js&"
export * from "./lawsuit-case-reply-card.vue?vue&type=script&lang=js&"
import style0 from "./lawsuit-case-reply-card.vue?vue&type=style&index=0&id=7a3ffd66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3ffd66",
  null
  
)

export default component.exports